import { loadMapPins } from './fetchMapPins';
import { loadScripts } from './PopupContentDialog';
import { loadMapLayers } from './fetchMapLayers';


let customMaps = [];

function initialView() {
  let map = this;
  let pinBounds = new google.maps.LatLngBounds();
  
  map.markers.forEach((m) => {
    pinBounds.extend(m.position);
  });

  if (typeof map.startBounds != 'undefined' && map.startBounds != ''){
    
    map.fitBounds(map.startBounds);
    if (map.initZoom != -1){
      map.setZoom(map.initZoom);
    }
  }
  else{
    if (map.initZoom == -1) {
      map.fitBounds(pinBounds);
    } else {
      map.setZoom(map.initZoom);
      map.setCenter(pinBounds.getCenter());
    }
  }
}
var jqueryLoadedRetryCounter=0;
function wireupMaps() {
  var jqueryLoaded = !(typeof $ === 'undefined' || $ === null) ;
  
  if(!jqueryLoaded && jqueryLoadedRetryCounter < 50){
    console.log("jQuery not loaded, wait and try again");
    jqueryLoadedRetryCounter++;
    window.setTimeout( wireupMaps, 100);
  }else{
    wireupMapsWorker();
  }
}

function wireupMapsWorker() {
  if (typeof google === 'undefined') return;
    loadScripts();

  document
    .querySelectorAll('[data-component="npws-custom-map"]')
    .forEach((component) => {
      let mapOptions = {
        center: { lat: -34.397, lng: 150.644 },
        mapTypeId: google.maps.MapTypeId.HYBRID,
      };

      // HTMLelement data attributes
      const { zoom, minZoom, maxZoom, mapType, mapId, mapTypeOptions, mapTypeControl,showFullScreen, showStreetView, showZoomControl, showMapTypeControl, mapTypeControlPosition, fullScreenPosition, streetViewPosition, zoomControlPosition, tilt, bounds } = component.dataset;
      
      let initZoom = -1;
      if (typeof zoom != 'undefined' && zoom != '') {
        initZoom = parseInt(zoom);
        mapOptions.zoom = initZoom;
      }
      if (typeof minZoom != 'undefined' && minZoom != '')
        mapOptions.minZoom = parseInt(minZoom);

      if (typeof maxZoom != 'undefined' && maxZoom != '')
        mapOptions.maxZoom = parseInt(maxZoom);

      if (typeof mapType != 'undefined' && mapType != '')
        mapOptions.mapTypeId = mapType;

      mapOptions.tilt = parseInt(tilt);
      mapOptions.zoomControl=(showZoomControl == "True");
      mapOptions.fullscreenControl=(showFullScreen == "True");
      mapOptions.streetViewControl=(showStreetView == "True");
      mapOptions.mapTypeControl=(showMapTypeControl == "True");

      mapOptions.fullscreenControlOptions={};
      mapOptions.fullscreenControlOptions.position=getGooglePosition(fullScreenPosition);

      mapOptions.mapTypeControlOptions={};
      mapOptions.mapTypeControlOptions.position=getGooglePosition(mapTypeControlPosition);

      mapOptions.zoomControlOptions={};
      mapOptions.zoomControlOptions.position=getGooglePosition(zoomControlPosition);

      var svPosition=getGooglePosition(streetViewPosition);
      if(!(svPosition == "")){
        mapOptions.streetViewControlOptions={};
        mapOptions.streetViewControlOptions.position=svPosition;    
      }

      if(typeof mapTypeControl != 'undefined'){
        if(mapTypeControl == "" || mapTypeControl == "Default"){
          mapOptions.mapTypeControlOptions.style=google.maps.MapTypeControlStyle.DEFAULT;        
        }else if(mapTypeControl == "Dropdown"){
          mapOptions.mapTypeControlOptions.style=google.maps.MapTypeControlStyle.DROPDOWN_MENU;        
        }else if(mapTypeControl == "Horizontal"){
          mapOptions.mapTypeControlOptions.style=google.maps.MapTypeControlStyle.HORIZONTAL_BAR;        
        }else{
          mapOptions.mapTypeControlOptions.style=google.maps.MapTypeControlStyle.DEFAULT;        
        }
      }        
        
      if (typeof mapTypeOptions != 'undefined' && mapTypeOptions != '')
      mapOptions.mapTypeControlOptions.mapTypeIds = mapTypeOptions.split('|');

      let map = new google.maps.Map(component, mapOptions);
      map.markers = [];
      map.initZoom = initZoom;

      map.startBounds = buildBounds(bounds);
     
      if (typeof mapId != 'undefined' && mapId != '') {
        loadMapPins(mapId, map);
        loadMapLayers(mapId, map)
      }

      map.setInitialView = initialView;

      map.showPopup = function (marker) {
        let gMap = this;
        let infoWindow = gMap.infoWindow;

        infoWindow.setContent(marker.popupHtml);
        infoWindow.open(gMap, marker);
      };

      customMaps.push(map);
    });
}

function buildBounds(bounds){
  var startBounds="";
  
  if (typeof bounds != 'undefined' && bounds != ''){
    var mapBoundsValues = bounds.split('|');
    var startBoundsTmp = new google.maps.LatLngBounds();
    
    if(mapBoundsValues.length<2)return startBounds;

    for (var i = 0; i < mapBoundsValues.length; i++) {
      mapBoundsValues[i] = mapBoundsValues[i].split(',');

      var currentLatLng = new google.maps.LatLng(
        mapBoundsValues[i][0],
        mapBoundsValues[i][1]
      );

      startBoundsTmp.extend(currentLatLng);
    }
    startBounds = startBoundsTmp;
  }
  return startBounds;
}

function getGooglePosition(position){
    switch(position){
      case "Bottom Center":
        return google.maps.ControlPosition.BOTTOM_CENTER;

      case "Bottom Left":
              return google.maps.ControlPosition.BOTTOM_LEFT;

      case "Bottom Right":
              return google.maps.ControlPosition.BOTTOM_RIGHT;

      case "Left Bottom":
              return google.maps.ControlPosition.LEFT_BOTTOM;

      case "Left Center":
              return google.maps.ControlPosition.LEFT_CENTER;

      case "Left Top":
              return google.maps.ControlPosition.LEFT_TOP;

      case "Right Bottom":
              return google.maps.ControlPosition.RIGHT_BOTTOM;

      case "Right Center":
              return google.maps.ControlPosition.RIGHT_CENTER;

      case "Right Top":
              return google.maps.ControlPosition.RIGHT_TOP;

      case "Top Center":
              return google.maps.ControlPosition.TOP_CENTER;

      case "Top Left":
              return google.maps.ControlPosition.TOP_LEFT;

      case "Top Right":
              return google.maps.ControlPosition.TOP_RIGHT;
    }
    return "";
}

function useGateway(mapPinId) {
  window.dispatchEvent(
    new CustomEvent('click-gateway', {
      detail: {
        mapPinId,
      },
    })
  );
  return false;
}


export { wireupMaps, useGateway };
